<template>
  <v-layout row wrap mt-4 mr-2 v-show="Object.keys(meta).length > 0 && meta.total > limit">
    <v-flex xs12 text-xs-center>
      <v-btn
        @click.native="changePage(1)"
        :disabled="meta.current_page === 1 || !meta.current_page"
        class="pagination-button"
        icon
        small>
        <v-icon pt-5>fa-caret-left</v-icon>
      </v-btn>
      <template v-if="meta.current_page > 4">
        <v-btn class="paginate-button elevation-0" @click="meta.current_page = 1">
          1
        </v-btn>
        ...
      </template>
      <template v-if="meta.current_page < range">
        <v-btn
          class="paginate-button elevation-0"
          v-for="(item, i) in range"
          :key="i"
          :class="{ 'k-orange-linear': meta.current_page === item }"
          :disabled="meta.current_page === item"
          @click="changePage(item)"
          v-if="meta.last_page >= item">
          {{ item }}
        </v-btn>
      </template>
      <template v-if="meta.current_page < meta.last_page - 1 && meta.last_page > range">
        ...
        <v-btn class="paginate-button elevation-0" @click="meta.current_page = meta.last_page">
          {{ meta.last_page }}
        </v-btn>
      </template>
      <v-btn
        @click.native="changePage(meta.last_page)"
        :disabled="meta.last_page === meta.current_page"
        class="pagination-button"
        icon
        small>
        <v-icon pt-5>fa-caret-right</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    meta: {
      type: Object,
      default: () => {},
    },
    limit: {
      type: Number,
      required: true,
    },
    range: {
      type: Number,
      default: 5,
    },
  },
  methods: {
    changePage(page) {
      this.$emit('changePage', page);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/global/Paginator.vue